<<template>
  <div class="detail-panel">
    <div class="btn-panel">
        <a v-if="this.action != 'View'" class="btn btn-default" @click="save">{{$rs["btn_save"]}}</a>
      <slot></slot>
    </div>
    <hr>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["dcId"]}}</span>
          <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.dcId"  oninput="if(value.length>5)value=value.slice(0,5)" >
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["dcName"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.dcName" maxlength="20">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["dcRemark"]}}</span>
          <textarea v-bind:readonly='action=="View"' v-model="data.dcRemark"
            rows="2" cols="30" type="text" class="form-control" />
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["dcIp"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.dcIp" maxlength="30">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["dcPort"]}}</span>
          <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.dcPort" oninput="if(value.length>5)value=value.slice(0,5)">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["status"]}}</span>
          <input type="checkbox" class="mui-switch"  v-bind:disabled='action=="View"' v-model="data.status">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["useType"]}}</span>
          <select class="form-control" v-model="data.useType" v-bind:disabled='action=="View"'>
            <option value="1">{{rs["useType1"]}}</option>
            <option value="2">{{rs["useType2"]}}</option>
            <option value="3">{{rs["useType3"]}}</option>
            <option value="4">{{rs["useType4"]}}</option>
            <option value="5">{{rs["useType5"]}}</option>
          </select>
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["deviceType"]}}</span>
          <select class="form-control" v-model="data.deviceType" v-bind:disabled='action=="View"'>
            <option value="1">{{rs["deviceType1"]}}</option>
            <option value="2">{{rs["deviceType2"]}}</option>
            <option value="3">{{rs["deviceType3"]}}</option>
            <option value="4">{{rs["deviceType4"]}}</option>
            <option value="5">{{rs["deviceType5"]}}</option>
          </select>
        </div>
    </div>
    
  </div>
</template>

<script>
import mixin from "@/fui/mixin";
export default {
  created(){
    if (this.action == "Add")  {
       this.data.dcPort = 4370
       this.data.dcSeqNo = 10
       this.data.status = 1
       this.data.useType = 1
       this.data.deviceType = 1
    }
  },
  methods: {
    checkInput(){
      if(this.data.status == true) this.data.status=1
      else this.data.status=0
       if (!this.checkNull(this.data.dcId, "nullid")) return false 
       if (!this.checkNull(this.data.dcIp, "nullip")) return false 
       if (!this.checkNull(this.data.dcPort, "nullport")) return false 
       return true
    }
  },
  mixins: [mixin.detail]
}
</script>
